import * as consts from "./prosaude";

export const URL_API = consts.URL_API;
export const username = consts.username;
export const password = consts.password;
export const sessionId = consts.sessionId;
